import React, { useEffect, useState } from 'react'
import kebabCase from 'lodash.kebabcase'
import clsx from 'clsx'
import { FeatureCard } from '@/components/molecules/FeatureCard/FeatureCard'
import { FeatureCardProps } from '@/components/molecules/FeatureCard/types'

export function FeaturesAccordion({ cards }: { cards: FeatureCardProps[] }) {
  const [selectedCard, setSelectedCard] = useState<number | null>(0)
  const [active, setActive] = useState(false)

  const featureCard = selectedCard !== null && cards[selectedCard]

  useEffect(() => {
    if (selectedCard !== null) {
      const accordionItem = document?.querySelector(`#${kebabCase(cards[selectedCard]?.card_title)}-accordion`)
      if (accordionItem && active) {
        accordionItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    }
  }, [selectedCard])

  const handleSelect = (index: number | null) => {
    setSelectedCard(index)
    setActive(true)
  }

  return (
    <ul className="flex flex-col">
      {cards.map((card, index) => {
        const isActive = index === selectedCard
        return (
          <li
            key={kebabCase(card.card_title)}
            id={`${kebabCase(card.card_title)}-accordion`}
            className={`mobile-${kebabCase(card.card_id)}`}
          >
            <button
              aria-expanded={isActive}
              type="button"
              onClick={() => handleSelect(index === selectedCard ? null : index)}
              className={clsx(
                'py-8 border-b-1 border-b-primary-300 w-full flex justify-between text-nowrap text-start text-bodyL text-text-dark-600',
                {
                  'border-b-2 border-b-primary-500 !text-text-brand-primary font-bold': isActive
                }
              )}
            >
              {card.card_title}
              {isActive ? (
                <i className={clsx('fa fa-thin-chevron-purple -rotate-90 transition duration-300 m-8')} />
              ) : (
                <i className={clsx('fa fa-thin-chevron rotate-90 transition duration-300 m-8')} />
              )}
            </button>
            {isActive && featureCard && <FeatureCard {...featureCard} index={selectedCard} />}
          </li>
        )
      })}
    </ul>
  )
}
